import React from 'react';
import { setCurrentView } from 'core/utils';
import { LinkOrderLineViewStore } from 'modules/order/stores';
import { LinkOrderLineTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new LinkOrderLineViewStore(rootStore, componentProps),
	'linkOrderLineViewStore'
)
class LinkOrderLine extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <LinkOrderLineTemplate {...this.props} />;
	}
}

export default LinkOrderLine;



// WEBPACK FOOTER //
// ./src/modules/order/pages/LinkOrderLine.jsx